module.exports = "pegasus_template/assets/blocks/social-1-theme6.png";